'use strict';

(function () {
    angular
        .module('tracking')
        .component('pairingListComponent', {
            templateUrl: 'tracking/components/pairing-list-component.tpl.html',
            controller: function ($timeout, $scope, applicationConstants) {
                var vm = this;
                vm.dataModel = {
                    selectedPairnig: null
                };

                vm.$onChanges = function (changeObj) {
                    if (changeObj.pairings && changeObj.pairings.currentValue && (changeObj.pairings.currentValue != changeObj.pairings.previousValue)) {
                        if (vm.pairings.length > 0) {
                            makePairingSelected(vm.pairings[0]);
                        }
                    }
                };

                $scope.$watch(function (d) {
                    return (vm.pairings && vm.pairings.length) || 0;
                }, function (d) {
                    if (vm.pairings && vm.pairings.length > 0) {
                        makePairingSelected(vm.pairings[0]);
                    }
                });

                vm.onPairingClick = function (pairing) {
                    makePairingSelected(pairing);
                };

                function makePairingSelected(pairing) {
                    vm.dataModel.selectedPairnig = pairing;
                    vm.onPairingSelected({pairing: vm.dataModel.selectedPairnig});
                }
            },
            bindings: {
                searchDateRange : '@',
                pairings: '<',
                onPairingSelected: '&'
            }
        });
})();
